import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../../core/models/handle-error';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';

import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { NgIf, NgStyle, NgFor, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ShareContentComponent } from '../../share-content/share-content.component';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-videos-channel-info',
    templateUrl: './videos-channel-info.component.html',
    styleUrls: ['./videos-channel-info.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgStyle, FormsModule, NgFor, RouterLink, NgxPaginationModule, ShareContentComponent, DatePipe, SearchFilterPipe, HighlightSearchPipe]
})
export class VideosChannelInfoComponent implements OnInit, OnDestroy {
  public videosList: any[];
  public shareContentObject = {};
  public subscription: ISubscription[];
  public screenWidth: any;
  public isSubscribed = true;
  public currentChannel;
  public serviceError = 'Loading data. Please wait...';
  public dateFormat: string;
  public search4video;

  page: number = 1;
  isPaginateFlag = false;
  count: number = 0;
  pageSize: number = 30;
  
  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  username: string;

  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail :  APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;
  APP_SETTINGS: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService,
    private videoService: VideosService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private changDetector: ChangeDetectorRef,
    private toastService: ToastConfigService,
    private analyticsService: AnalyticsService,
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    let channelNumber;
    channelNumber = this.route.snapshot.params['id'];
    this.getAllData(channelNumber);
    // broadcast channel number via service to load the respective data on channel-info component
    this.subscription.push(this.utilityService.broadcastChannelNumber$.subscribe(value => {
      this.getAllData(value);
    }));
    // close share content modal when user hits submit
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
  }
  getAllData(channelNumber) {
    this.currentChannel = '';
    this.videosList = [];
    this.spinnerService.show('bmwSpinner');
    this.videoService.getChannelsData().subscribe(data => {
    this.currentChannel = data.find(channel => channel.channelNumber === channelNumber);
    this.videoService.getVideosFromChannel(channelNumber).subscribe(value => {
        this.spinnerService.hide('bmwSpinner');  
        this.videosList = value;
      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
        }
      );
    });
  }
  shareContent(id, type, channel, videoDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      channel: channel,
      videoDisplayNumber:videoDisplayNumber
    };
  }
  toggleSubscription(channelNumber) {
    this.videoService.toggleSubscribeChannel(this.username, channelNumber).subscribe(data => {
      this.isSubscribed = data.some(channel => channel.channelNumber === channelNumber);
      this.utilityService.publishChannelSubscription(true);
    });
  }
  addVideoToWatchlist(videoId, videoDisplayNumber) {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Videos', videoDisplayNumber, 'saved');
    //Analytics call
    this.videoService.addVideoToWatchlist(this.username, videoId).subscribe(data => {
      if (data) {
        this.toastService.popToast('Video added to watchlist');
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  pageNumChange(event) {
    this.page = event;
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }

  disablePagination() {
    this.isPaginateFlag = true;
  }
}
